import { FC } from 'react';
import Edit from 'components/elements/components/Edit';

const Screen: FC = () => {
  return (
    <Edit
      elementsEntityName="client-element"
      elementsEndpoint="client-elements"
    />
  );
};

export default Screen;
